import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { color } from 'framer-motion';
import { CopyBlock, dracula } from "react-code-blocks";

const JavaScriptLesson37 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code1 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  console.log(fruits[0]); //apple
  console.log(fruits[1]); //mango
  console.log(fruits[2]); //pear
  `
  );
  const code2 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  console.log(fruits.length); //4
  `
  );
  const code3 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  let veg = ["carrot", "spinach", "lettuce", "tomato"]
  console.log(fruits.concat(veg)); //["apple", "mango", "pear", "grape", "carrot", "spinach", "lettuce", "tomato"]
  `
  );
  const code4 = (
  'text',
  `
  array.join(separator)
  `
  );
  const code5 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  console.log(fruits.join("+"));
  `
  );
  const code6 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  fruits.push("banana");
  console.log(fruits); //["apple", "mango", "pear", "grape", "banana"]
  `
  );
  const code7 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  fruits.reverse();
  console.log(fruits); //["grape", "pear", "mango", "apple"]
  `
  );
  const code8 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  fruits.shift();
  console.log(fruits.shift()); //"mango", "pear", "grape"]
  `
  );
  const code9 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  fruits.unshift("water mellon");
  console.log(fruits); //["water mellon", "apple", "mango", "pear", "grape"]
  `
  );
  const code10 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  fruits.sort();
  console.log(fruits); //["apple", "grape", "mango", "pear"]
  `
  );
  const code11 = (
  'text',
  `
  let fruits = ["apple", "mango", "pear", "grape"];
  console.log(fruits.pop()); //grape
  `
  );
  const code12 = (
  'text',
  `
  let snacks = ["meatpie", "sausage", "biscuit", "pizza"];
  let drinks = ["Coke", "Sprite", "Malt", "Fanta"];
  snacks.push(...drinks);
  console.log(snacks); //combines all elements of snacks and drinks
  `
  );
  const code13 = (
  'text',
  `
  const numbers = [1,2,5,6,9,8];
  const total = numbers.reduce((a,b) => return a + b );
  console.log(total); //31
  `
  );
  const code14 = (
  'text',
  `
  let numbers = [1,2,5,6,9,8];
  const maxVal = numbers.reduce((a,b) => return a < b ? a : b )
  console.log(maxVal); //9
  `
  );
  const code15 = (
  'text',
  `
  let numbers = [1,2,5,6,9,8];
  const minVal = numbers.reduce((a,b) => return a < b ? a : b )
  console.log(maxVal); //1
  `
  );
  const code16 = (
  'text',
  `
  let x = [1,3,4,5,6,7,8,9,10,11,12];
  function multiple(val){
    return val % 3 === 0;
  }
  let result = x.filter(multiple);
  console.log(result) //3,6,9,12
  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3><strong>Arrays</strong></h3>
    <p>An array is used to store multiple values in a single variable. It is also used to store a collection of data.</p>
    <p>The index of an array begins from 0.</p>
    <CopyBlock
    language={language}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>Array Length</strong></h4>
    <p>This specifies the number of elements in an array.</p>
    <CopyBlock
    language={language}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>concat()</strong></h4>
    <p>Returns a new array comprising of an array joined with other array</p>
    <CopyBlock
    language={language}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>join()</strong></h4>
    <p>This joins all elements of an array to a string.</p>
    <h4 className="mt-3">Syntax</h4>
    <CopyBlock
    language={language}
    text={code4}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <p className="mt-3"><strong>Separator:</strong> specifies a string to separate each element of the array. If omitted, the array elements are separated by a comma.</p>
    <CopyBlock
    language={language}
    text={code5}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>push()</strong></h4>
    <p>Appends the given element to the last index of the array and returns the array.</p>
    <CopyBlock
    language={language}
    text={code6}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>reverse()</strong></h4>
    <p>This reverses the elements in an array. The first array element becomes the last and the last becomes the first.</p>
    <CopyBlock
    language={language}
    text={code7}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>shift()</strong></h4>
    <p>This removes the first element from an array and returns the array.</p>
    <CopyBlock
    language={language}
    text={code8}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>unshift()</strong></h4>
    <p>This method adds one or more elements to the beginning of an array and returns the new length of the array.</p>
    <CopyBlock
    language={language}
    text={code9}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>sort()</strong></h4>
    <p>Prints out array elements in ascending order.</p>
    <CopyBlock
    language={language}
    text={code10}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>pop()</strong></h4>
    <p>Removes the last element from an array and returns that element.</p>
    <CopyBlock
    language={language}
    text={code11}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>Rest Parameter</strong></h4>
    <p>The rest parameter is an ES6 syntax that is used to represent an indefinite number of elements as an array.</p>
    <p>Rest parameters can also be used to get the rest elements in an array.</p>
    <CopyBlock
    language={language}
    text={code12}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>reduce()</strong></h4>
    <p>The <strong>reduce()</strong> method executes a reducer function for an array element and returns a single value.</p>
    <p>Now, let's get the total, minimum and maximum value of an array using the <var>reduce()</var> method</p>
    <h4>Get the Sum of an Array</h4>
    <CopyBlock
    language={language}
    text={code13}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <h4 className="mt-3">Get the Maximum value in an array</h4>
    <CopyBlock
    language={language}
    text={code14}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <h4 className="mt-3">Get the Minimun value in an array</h4>
    <CopyBlock
    language={language}
    text={code15}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>Array Filter</strong></h4>
    <p>The <strong>filter</strong> method for Array checks the array against a given condition</p>
    <h4>Example</h4>
    <p>Given an array, find and print all multiples of 3</p>
    <p class="font-weight-bold">let x = [1,3,4,5,6,7,8,9,10,11,12]</p>
    <CopyBlock
    language={language}
    text={code16}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>


    <div class="alert alert-secondary mt-3" role="alert">
    <h3><strong>Summary</strong></h3>
    <ul class="list-group">
      <li class="list-group-item">Arrays store multiple values in a single variable.</li>
      <li class="list-group-item">The stored values are referred to as elements.</li>
      <li class="list-group-item">Array index begins from 0</li>
      <li class="list-group-item">The array methods are used to manipulate the array and its elements.</li>
    </ul>
    </div>



    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson37
